var btnnextCnt = 0;
var radioinlinevalue = 0;
var CountToExamTimer=0;
var ColorToExamTimer=0;
var time = 0;
var sec  = 0;
var min  = 0;
var hour = 0;
var timecolor = 0;
var TimerText = '';

var rcolor = 0;
var gcolor = 0;

var Exam;
Exam = {

    TimeSetColor: function () {
        TimerText.style.color = 'RGB(' + rcolor + ',' + gcolor + ',38)';
        //   gcolor--;
        rcolor++;
        if (rcolor == 255) {
            clearTimeout(ColorToExamTimer);
        }
    },

    CountToExam: function () {

        time--;
        sec--;
        if (sec == -1) {
            min--;
            sec = 59;
        }
        if (min == -1) {
            hour--;
            min = 59;
        }
        sessionStorage.setItem('timer', time);
        TimerText.innerHTML = Exam.TimeToStr(hour, min, sec, ':');
        if (time == 0) {
            clearTimeout(CountToExamTimer);
            sessionStorage.setItem('timer', -10);
            var dc = document.getElementById('sublimendtest');
            dc.removeAttribute('disabled');
            dc.removeAttribute('title');
            this.SaveAndCloseTest();
            dc.click();

        }
    },


    SaveAndCloseTest: function () {
        try {
            sessionStorage.setItem('timer', -10);
            var jsn = JSON.parse(document.getElementById('tests_saved').value.toString());
            var user_id = jsn['user_id'];
            var test_id = jsn['test_id'];
            var grp_id = jsn['question_group'];
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
            // $.ajax({
            //     url: '/closetest',
            //     type: 'POST',
            //     data: {_token: CSRF_TOKEN, user_id: user_id, test_id: test_id, timer: time, grp_id: grp_id},
            //     dataType: 'JSON',
            //     success: function (data) {
            //         //   alert(data.toArray());

            //     }
            // });
        } catch (e) {

        }
    },

    FormatTimeNum: function (num) {
        var res = '';
        if (num < 10) {
            res = res + '0' + Number(num);
        } else {
            res = res + Number(num);
        }
        return res;
    },

    SaveContext: function (tis) {
        var id = radioinlinevalue;
        var tab = tis.toString().replace(/[^0-9]/g, "");
        //alert(radioinlinevalue);
        var dc = document.getElementById('tests_saved');
        var jsn = JSON.parse(document.getElementById('tests_saved').value.toString());
        var user_id = jsn['user_id'];
        var test_id = jsn['test_id'];
        var grp_id = jsn['question_group'];
        grp_id = grp_id[tab - 1]
        var tabstat = 1;
        var dd = document.getElementsByClassName('cardTab' + tab)[0].classList[1];
        tab++;
        if ('exam-tab-qwe-warning' == dd) {
            tabstat = 0;

        }

        // var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
        // $.ajax({
        //     url: '/savetodb',
        //     type: 'POST',
        //     data: {
        //         _token: CSRF_TOKEN,
        //         timer: time,
        //         user_id: user_id,
        //         test_id: test_id,
        //         qwe_id: id,
        //         tab: tab,
        //         grp_id: grp_id,
        //         tabstat: tabstat
        //     },
        //     dataType: 'JSON',
        //     success: function (data) {
        //         //alert(data.toArray());

        //     }
        // });
    },


    TimeToStr: function (hour, min, sec, div = ':') {
        var time = '';
        time = time + this.FormatTimeNum(hour);
        time = time + div;
        time = time + this.FormatTimeNum(min);
        time = time + div;
        time = time + this.FormatTimeNum(sec);
        return time;
    },


    ParseTime: function (time) {
        var tm = time;
        var hour = div(tm, 3600);
        tm = tm % 3600;
        var min = div(tm, 60);
        tm = tm % 60;
        var sec = tm;
        var ret = [hour, min, sec];
        return ret;
    },

    startexam: function () {
        try {
            TimerText = document.getElementById('exam_timer');
        } catch (e) {
            return;
        }
        var stime = TimerText.innerHTML;
        hour = Number(stime[0] + stime[1]);
        min = Number(stime[3] + stime[4]);
        sec = Number(stime[6] + stime[7]);
        time = (hour * 60 * 60) + (min * 60) + sec;
        if (!sessionStorage.getItem('timer')) {
            sessionStorage.setItem('timer', time);
        }
        var tm = sessionStorage.getItem('timer');
        if (tm > 0) {
            time = tm;
            var ret = Exam.ParseTime(time);
            hour = ret[0];
            min = ret[1];
            sec = ret[2];
            TimerText.innerHTML = Exam.TimeToStr(hour, min, sec, ':');
        } else {
            sessionStorage.setItem('timer', time);
        }

        timecolor = div(time * 1000, 255);
        if (TimerText != null) {
            CountToExamTimer = setInterval($.proxy(Exam.CountToExam, Exam), 1000);
            ColorToExamTimer = setInterval($.proxy(Exam.TimeSetColor, Exam), timecolor);
        }
    },

    radioinlineClick: function () {
        if (radioinlinevalue != this.control.value) {

            radioinlinevalue = this.control.value;
            var cn = this.control.name;
            var id = this.parentNode.id.toString().replace(/[^0-9]/g, "");
            Exam.SaveContext(document.getElementById('sublim' + id).id);

            var cl = document.getElementById('navclass' + id).classList;
            cl.replace('exam-tab-qwe-warning', 'exam-tab-qwe-success');
            if (btnnextCnt == 0)
                btnnextCnt = document.getElementsByClassName('nav-pills')[0].childElementCount;
            dc = document.getElementsByClassName('nav-pills')[0].children[0];
            var b = 1;
            for (var i = 1; i <= this.btnnextCnt; i++) {
                if (dc.firstChild.classList[1] == 'exam-tab-qwe-warning') {
                    b = 0;
                    break;
                }
                dc = dc.nextElementSibling;
            }
            if (b == 1) {
                var dc = document.getElementById('sublimendtest');
                dc.removeAttribute('disabled');
                dc.removeAttribute('title');
                btnnextCnt = 0;
            }
        }
    }
};

if( $("#exam_timer").length != 0 ) {
    document.addEventListener("DOMContentLoaded", Exam.startexam);
}

    function div(val, by){
        return (val - val % by) / by;
    }


    // $(window).on("beforeunload", function (event) {
    //     var e = e || window.event;
    //     SaveAndCloseTest();
    // });

    $(document).on('click','.radio-inline',Exam.radioinlineClick);

    $(document).on('click','#sublimendtest',Exam.SaveAndCloseTest);

    setTimeout( () => {
        $(".btn-next").on('click', function () {
            try {
                Exam.SaveContext($(this)[0].id);
            }catch (e) {

            }
            var cardID = $(this).attr('aria-controls');

            $('.tab-pane').hide();

            $('.panel').find('.active').removeClass('active');

            $('li').find('.' + cardID).addClass('active');

        })
    },
500);
